<template>
    <component
        :is="href ? 'a' : 'span'"
        :href="href"
        class="def-link-secondary"
        :style="`text-decoration-style: ${ line }`"
    >
        <slot />
    </component>
</template>

<script>
export default {
    name: 'DefLinkSecondary',
    props: {
        href: {
            type: String,
        },
        line: {
            type: String,
            default: 'solid',
        }
    },
}
</script>

<style lang="scss" scoped>
.def-link-secondary{
    text-decoration-line: underline;
    text-underline-position: under;
    transition: .2s linear color;
    cursor: pointer;
    text-underline-color: currentColor;
    color: #757575;
    &:hover{
        color: var(--color-dark-grey);
    }
    &_dashed{
        text-decoration-style: dashed;
        //text-underline-style: dotted;
    }
}
</style>